import React from 'react';

import { useSelector } from 'react-redux';

import { isLoadingSelector } from './selector';

import TinyLoading from '@/components/TinyLoading';

const Loading: React.FC = () => {
  const isLoading = useSelector(isLoadingSelector);
  if (isLoading) {
    return <TinyLoading />;
  }
  return null;
};

export default Loading;
